import api from "./axios";

const UsersService = {
  /**
   * Get all users
   */
  async getAll() {
    const response = await api.get("/users");
    return response.data;
  },

  /**
   * Get a user by ID
   */
  async getById(id) {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },

  /**
   * Create a new user
   */
  async create(userData) {
    const response = await api.post("/users", userData);
    return response.data;
  },

  /**
   * Update an existing user
   */
  async update(id, userData) {
    const response = await api.put(`/users/${id}`, userData);
    return response.data;
  },

  /**
   * Delete a user
   */
  async delete(id) {
    await api.delete(`/users/${id}`);
  },
};

export default UsersService;
